import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';

export const DIMENSION_POPUP_OK_TEXT = 'Apply';
export const DIMENSION_POPUP_TITLE = 'Select dimensions to view';

export const hasAdDimensions = (dimensionList: string[], dimensionCategories = {}) => {
  return dimensionCategories?.[DIMENSION_TYPES_CONSTANTS.ai]?.some((d) =>
    dimensionList.includes(d.key),
  );
};

// Dimensions that should render a "Beta" badge in the dimension selector popup
// and in dimension dropdowns. Keyed by groupBy / backend name. Both casings of
// the Ended Status group_by are listed to stay robust to ENDED_STATUS/EndedStatus.
export const betaDimensionList = ['ENDED_STATUS', 'EndedStatus'];

const betaDimensionNames = ['Ended Status'];

export const isBetaDimension = (
  dimension?: string | { key?: string; groupBy?: string; backendName?: string; name?: string },
): boolean => {
  if (!dimension) return false;
  if (typeof dimension === 'string') {
    return betaDimensionList.includes(dimension);
  }
  const ids = [dimension.key, dimension.groupBy, dimension.backendName];
  if (ids.some((id) => !!id && betaDimensionList.includes(id))) {
    return true;
  }
  return !!dimension.name && betaDimensionNames.includes(dimension.name);
};
